// price.listPrice does not exist in the Elasticsearch product index.
// CriteriaParser has special handling for cheapestPrice.percentage — it routes to
// cheapest_price_percentage_filter.groovy which checks the actual indexed
// cheapest_price_*_percentage fields (only present when a discount exists).
const ON_SALE_ES_FILTER = {
    type: 'range' as const,
    field: 'cheapestPrice.percentage',
    parameters: { lt: 100 },
}

export function useOnSaleFilter() {
    const route = useRoute()

    const isOnSalePage = computed(() => route.query.isOnSale === '1')

    /**
     * For SSR via useCategorySearch (/category/{id}).
     * Keeps isOnSale=1 in the request body so the backend OnSaleListingSubscriber
     * can read it and add the correct RangeFilter via ProductListingCollectFilterEvent.
     */
    function withOnSaleFilter(query: Record<string, unknown>): Record<string, unknown> {
        if (isOnSalePage.value) {
            return { ...query, isOnSale: '1' }
        }
        const { isOnSale: _removed, ...rest } = query
        return rest
    }

    /**
     * For client-side via useCategoryListing (/product-listing/{id}).
     * Goes through Elasticsearch (ProductListingLoader adds STATE_ELASTICSEARCH_AWARE).
     * Uses cheapestPrice.percentage > 0 instead of price.listPrice != null because
     * price.listPrice does not exist in the ES product index.
     */
    function withOnSalePostFilter(query: Record<string, unknown>): Record<string, unknown> {
        const { isOnSale: _removed, ...rest } = query
        if (isOnSalePage.value) {
            return { ...rest, 'post-filter': [ON_SALE_ES_FILTER] }
        }
        return rest
    }

    return { isOnSalePage, withOnSaleFilter, withOnSalePostFilter }
}
